export const shouldDisplayLinkEnrollmentFlow = (email: string | undefined) => {
  return email?.endsWith('@olivineinc.com');
};
